// Error-state feedback for the "Complete your set" add-on ADD buttons.
// The theme's ProductForm dispatches a bubbling `cart:error` on the form when
// /cart/add fails; flag the originating ADD button so the CSS error state shows.
document.addEventListener('cart:error', function (event) {
  var form = event.target;
  if (!(form instanceof Element)) return;
  var wrapper = form.closest('.pdp-cts__add-form');
  if (!wrapper) return;
  var button = wrapper.querySelector('.pdp-cts__add-button');
  if (!button) return;
  button.classList.add('pdp-cts__add-button--error');
  setTimeout(function () {
    button.classList.remove('pdp-cts__add-button--error');
  }, 3000);
});
